module.exports = __webpack_public_path__ + "img/1.2bb406d8.png";